import { orderBy } from 'lodash';

const roundHalf = num => Math.round(num * 2) / 2;

export const findCategoryByName = (categories = [], name = '') =>
  categories.find(category => category.name === name);

export const calculateCategoriesBenchmarks = ({
  categories,
  potentialSavings
}) => {
  const { enabled, benchmark: psBenchmark } = potentialSavings;
  const orderedCategories = orderBy(categories, ['benchmark'], ['desc']);
  const partialSaving = (100 - potentialSavings.benchmark) / 100;
  let sum = 0;
  const categoriesBenchmarks = orderedCategories.reduce(
    (acc, category, idx) => {
      const isLast = idx === orderedCategories.length - 1;
      const categoryBenchmark = isLast
        ? 100 - sum - (enabled ? 0 : psBenchmark)
        : roundHalf(
            enabled
              ? category.benchmark / partialSaving
              : category.benchmark * partialSaving
          );

      sum += Number(categoryBenchmark);

      return {
        ...acc,
        [category.key]: categoryBenchmark
      };
    },
    {}
  );

  return categoriesBenchmarks;
};
